'use client';

import cn from 'classnames';

import { InternshipCard } from '@/app/bootcamp/components/InternshipCard';
import { MockBootcampProps } from '@/mocks/bootcamp';

import { CarouselBase } from '../../CarouselBase';
import s from './InternshipCarousel.module.scss';

const InternshipCarousel = ({ slides }: { slides: MockBootcampProps[] }) => {
  return (
    <section className={cn(s.root)}>
      <div className={s.carouselWrapper}>
        <CarouselBase
          slidesCount={slides.length}
          withPagination
          carouselClassName={s.carousel}
          rewind
          navigationClassName={s.navigation}
          slideClassName={s.slide}
          analyticsName="internship-carousel"
          slidesSpacing={16}
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            637: {
              slidesPerView: 1.6,
            },
            768: {
              slidesPerView: 2.1,
            },
          }}
        >
          {slides.map(({ slug, isClosed, hero }, index) => {
            return (
              <InternshipCard
                key={`${slug}_${index}`}
                slug={slug}
                isClosed={isClosed}
                hero={hero}
              />
            );
          })}
        </CarouselBase>
      </div>
    </section>
  );
};

export { InternshipCarousel };
